import ListViewCtrl from "../util/ListViewCtrl";

export default class CennikListCtrl extends ListViewCtrl {

  static $inject = ["itemSource", "CennikService", "$window", "FileService"];

  constructor(itemSource, CennikService, $window, FileService){
    super(itemSource);
    this.CennikService = CennikService;
    this.FileService = FileService;
    this.$window = $window;
  }

  updateList() {
    this.CennikService.listSource().wait().then(result => {
      this.itemSource = result;
    });
  }

  onDeleteCennikClicked(index) {
    if (confirm('Naozaj odstrániť?')) {
      this.CennikService.delete(this.itemSource.result[index].id).then(() => {
        this.itemSource.result.splice(index, 1);
      })
    }
  }

  onExportCennikClicked(index) {
    let cennik = this.itemSource.result[index];
    this.CennikService.exportXml(cennik.id).then(result => {
      let blob = new Blob([result], {type: "text/xml"});
      let xmlUrl = this.$window.URL.createObjectURL(blob);

      let document = this.$window.document;
      let anchor = document.createElement('a');
      anchor.style = "display: none";
      anchor.href = xmlUrl;
      anchor.download = `cennik-${cennik.kod}-${new Date().toJSON().slice(0,10)}.xml`;

      document.body.append(anchor);

      anchor.click();
    });
  }

  onImportXML(file) {
    this.FileService.read(file).then(result => {
      this.CennikService.importXml(result.content).then(result => {
        if (result.changeLog.length)
          this.changes = result.changeLog;
        if(result.errorLog.length)
          this.errors = result.errorLog;
          this.updateList();
      });
    })
  }

}



// WEBPACK FOOTER //
// ./src/Cennik/CennikListCtrl.js